import { searchIcon } from "icons"
import React from "react"
import HourglassIcon from "@mui/icons-material/HourglassTop"

export const SearchBox: React.FC<{
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    value?: string
    placeholder?: string
    defaultValue?: string
    inProgress?: boolean
}> = React.memo(({inProgress, ...inputProps}) => {
    return <div className='relative w-full'>
        <div className='absolute' style={{
            top: '50%', left: '2px', transform: 'translateY(-50%)', height: '20px', width: '20px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>{
            inProgress
            ? <HourglassIcon className="animate-spin" sx={{height: '20px', width: '20px'}} />
            : searchIcon
        }</div>
        <input
            {...inputProps}
            className='w-full'
            type='text'
            style={{
                borderRadius: '5px', height: '30px', paddingLeft: '30px',
                fontFamily: 'Calibri,Arial,Helvetica,sans-serif', fontSize: '12px',
            }} />
    </div>
})
